import * as React from "react";
import * as ReactDOM from "react-dom";
import {getQueryStringParameter} from "./utility/StringUtilities";
import $ = require("jquery");
window["jQuery"] = $;
window["$"] = $;
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import bs = require("bootstrap");
// ReSharper disable once UnusedLocals
let bs2 = bs;

import { DarienShell } from "./components/darien/DarienShell";

let shoppingBasketDom = document.getElementById("darienbasket-app");

let mode = getQueryStringParameter("mode");
ReactDOM.render(
	// @ts-ignore:
	<MuiThemeProvider>
	<div className="container">
		<DarienShell mode={mode}/>
	</div>
</MuiThemeProvider>,
	shoppingBasketDom
);


// WEBPACK FOOTER //
// ./src/darien.tsx